import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { NotificationService } from "../../../core/services/notification.service";
import { FineTypesArray } from "../../../requests/request-components/activity-fines/fine-type.model";
import { ActionDataResult } from "../../models/core/ActionDataResult";

@Injectable()
export class ActivityFineTypesService {

    protected controllerName = 'fine-types';
    protected controllerVersion = 1;

    constructor(protected http: HttpClient,
        protected notificationService: NotificationService) {
    }

    protected baseUrl(): string {
        return `${environment.finesAddress}v${this.controllerVersion}/${this.controllerName}`;
    }

    public getFineTypes(): Observable<FineTypesArray[]> {
		return this.http.get<ActionDataResult<FineTypesArray[]>>(`${this.baseUrl()}`)
			.pipe(tap(resp => {
				if (!resp.isSuccessful) {
                    this.notificationService.error({ title: 'Сервис штрафов и событий', message: resp.errorDescription });
				}
			}, errorResponse => {

				if (errorResponse.status === 904)
					return;

                this.notificationService.error({ title: 'Сервис штрафов и событий', message: errorResponse.errorDescription });
			}))
            .map(m => { return m.data });
    }
}
